module.exports = __webpack_public_path__ + "img/betsize_btn.7e18bbb4.png";